var request = require('./request');
var Promise = require('bluebird');
var config = require('./config');
var resolve = require('./resolve');

exports.GetCharityRegistrationOrganisations = function() {
	return request.get(resolve(config.url(),'/charityRegistrationOrganisations')).promise();
}
